import { Role } from '@personal-area/global/users/models';

export function calculateBalanceFixed(
  type: Role | undefined,
  balance: number,
  credit: number,
  equity: number
): number {
  if (!type) {
    return 0;
  }

  if (type === Role.Exchanger) {
    return balance / 100;
  }

  return (equity - credit) / 100;
}
